import { CustomerException } from '@/domain/stripe/customer/repository/contract/exception/CustomerException'

export class CustomerNotFoundException extends CustomerException {

}
